// react
import { useEffect } from 'react';

// components
import { PageTemplate } from '@karehero/llama/pwa/templates/PageTemplate/PageTemplate';
import { PageHeader } from '@karehero/llama/pwa/atoms/PageHeader/PageHeader';

import CareSearchPage from '@karehero/llama/components/pages/CareSearch/CareSearch';

// views
import { DirectorySearchView } from 'views/Directory';

// store
import {
  useGetShortlistBySessionQuery,
  useGetShortlistDataBySessionQuery,
  useMarkShortlistCareHomeSecuredMutation,
} from 'store/api/shortlist';

// tracking
import { TrackingEvent, useTracking } from 'hooks';

/**
 * CareSearch shows 
a search bar and a list of care homes based on the user's search criteria and shortlist.
 */
export const CareSearch = () => {
  // hooks
  const { data: careHomeShortlistData } = useGetShortlistDataBySessionQuery();
  const { data: careHomeShortlist } = useGetShortlistBySessionQuery();
  const [markCareHomeSecured] = useMarkShortlistCareHomeSecuredMutation();

  const { track } = useTracking();

  // effects
  useEffect(() => {
    if (careHomeShortlist && careHomeShortlistData) {
      track(TrackingEvent.ShortlistViewed, {
        id: careHomeShortlistData.id,
      });
    }
  }, [careHomeShortlistData, careHomeShortlist, track]);

  return (
    <PageTemplate
      headerSlot={
        <PageHeader
          title='Care Search'
          description='Search and compare care providers in your area.'
        />
      }
      contentSlot={
        <>
          {careHomeShortlist && careHomeShortlistData && (
            <CareSearchPage
              shortlist={careHomeShortlist}
              shortlistData={careHomeShortlistData}
              onMarkSecured={markCareHomeSecured}
            />
          )}
          <DirectorySearchView />
        </>
      }
    />
  );
};

export default CareSearch;
